import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import ArrowBackIcon from "../assets/images/Arrow Left.svg";
function getLeft(leftPush, leftNormal) {
  if (leftPush) {
    return "10vw";
  }
  if (leftNormal) {
    return "24px";
  } else {
    return "15vw";
  }
}
const BackButton = ({ onBackStep, leftPush, leftNormal, margin }) => {
  return (
    <>
      <IconButton
        className="back-button-sm"
        onClick={() => onBackStep()}
        sx={{
          display: { xs: "flex", sm: "none", md: "none", lg: "none" }, // Show on xs, sm, md, and hide on lg and up
          alignItems: "center !important",
          position: "relative",
          bgcolor: "#2A4876",
          color: "white",
          borderRadius: "20px", // Make it rounded
          padding: "8px 16px !important", // Adjust padding to get the pill shape
          "&:hover": { bgcolor: "#1F3553" },
          marginTop: margin == 0 ? 0 : "10px",
          zIndex: 99,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", marginRight: "8px" }}>
          <img src={ArrowBackIcon} alt="Back" />
        </Box>
        <Typography sx={{ fontWeight: "bold", fontSize: "14px" }}>
          Back
        </Typography>
      </IconButton>
      {/* Back Button in large devices */}
      <IconButton
        className="back-button-lg"
        onClick={() => onBackStep()}
        sx={{
          display: { xs: "none", sm: "flex", md: "flex", lg: "flex" }, // Hide on xs, sm, md, and show on lg and up
          alignItems: "center !important",
          position: "absolute",
          // Single source for the responsive flip (previously also in
          // App.css): below 1024px the button renders in flow.
          "@media (max-width: 1024px)": { position: "relative" },
          // Shifts the static position clear of the fixed Topnav bar /
          // trimmed headers — without it the button sits flush under them.
          marginTop: "12px",
          // content-container is a flex column: without these the in-flow
          // (<=1024px) variant stretches into a full-width band.
          alignSelf: "flex-start",
          width: "fit-content",
          left: getLeft(leftPush, leftNormal),
          bgcolor: "#2A4876",
          color: "white",
          borderRadius: "20px", // Make it rounded
          padding: "8px 16px !important", // Adjust padding to get the pill shape
          "&:hover": { bgcolor: "#1F3553" },
          zIndex: 99,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", marginRight: "6px" }}>
          <img
            style={{ width: "12px", height: "12px" }}
            src={ArrowBackIcon}
            alt="Back"
          />
        </Box>
        <Typography sx={{ fontWeight: "bold", fontSize: "12px" }}>
          Back
        </Typography>
      </IconButton>
    </>
  );
};

export default BackButton;
